export enum PasswordSetResult {
  // Not yet started
  NA = 'NA',
  // Password set failed
  Failed = 'Failed',
  // Password set Succeeded
  Succeeded = 'Succeeded',
  // Password rejected because it matches one of the last N passwords
  PasswordReuseError = 'PasswordReuseError',
}

/**
 * Maps TMS `detail` strings to specific PasswordSetResult values.
 * Add a new entry here to handle additional TMS-specific error messages.
 */
export const PASSWORD_DETAIL_ERROR_MAP: Record<string, PasswordSetResult> = {
  'A jelszó nem egyezhet meg az utoljára megadott 5 jelszóval!': PasswordSetResult.PasswordReuseError,
};
